import React, { useState, useEffect, useContext, use } from "react";
import FilterProductSearch from "./FilterProductSearch";
import { useStyles } from "../../assets/styles/Theme";
import { useTheme } from "@mui/material/styles";
import {
  Bankdata,
  Industrydata,
  sampleData,
} from "../../components/grid/GridData";
import {
  Box,
  TextField,
  Typography,
  Button,
  Autocomplete,
  InputAdornment,
  Divider,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormHelperText,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import { useSelector } from "react-redux";
import ViewDataGridProduct from "../../components/grid/ViewDataGridProduct";
import { itemData, supplierData } from "../grid/GridDataGrn";
import { externalgetApi, externalpostApi } from "../../services/externalApis";
import {
  SETTING_API_01,
  SETTING_API_07,
  SETTING_API_13,
} from "../../api/ApiModel";
import { useNavigate } from "react-router-dom";
import {
  CON_STATUS_ACTIVE,
  CON_TAX_PAGE_CODE,
} from "../../utils/sys/Constants";
import SystemAlert from "../../components/common/SystemAlert";
import { useLocation } from "react-router-dom";
import { SUPPLIER_API_02, SUPPLIER_API_04 } from "../../api/ApiModel";
const ProductsBasicInfo = ({ suprefcode }) => {
  const theme = useTheme();
  const styles = useStyles(theme);
  const navigate = useNavigate();
  const location = useLocation();
  const [filteredRows, setFilteredRows] = useState([]);
  const [alertOpen, setAlertOpen] = useState(false); // State to control alert visibility
  const [alertType, setAlertType] = useState("success"); // Type of alert (e.g., success, error, warning)
  const [alertMessage, setAlertMessage] = useState("");
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const [searchQuery, setSearchQuery] = useState(""); // State for search input
  const [data, setData] = useState(null);
  const [datapro, setDatapro] = useState(null);
  const [datatax, setDatatax] = useState(null);
  const SYS_USER = useSelector((state) => state.user) || {};
  const { LOCCODE, STAFFMAPLOCODE, COMPCODE, USERNAME } =
    SYS_USER.USER_PARAM || {};
  const { selectedItem } = location.state || {};
  const isEdit = location.state?.actionText === "Edit";

  useEffect(() => {
    if (selectedItem) {
      setSelectedItemDetails({
        productcode: selectedItem.productcode || "",
        barcode: selectedItem.barcode || "",
        productname: selectedItem.productname || "",
        istax: selectedItem.istax || "",

        taxcode: selectedItem.taxcode || "0",
        taxtype: selectedItem.taxtype || "",
        supproductcode: selectedItem.supproductcode,
      });
    }
  }, [selectedItem]);

  const [filters, setFilters] = useState({
    productname: "",
    catname: "",
    brandname: "",
    // add more if needed
  });

  const [selectedItemDetails, setSelectedItemDetails] = useState({
    supproductcode: "",
    productname: "",
    productcode: "",
    barcode: "",
    istax: "",

    taxcode: "0",
    taxtype: "",
  });
  const [error, setError] = useState("");
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    const trimmedValue = typeof value === "string" ? value.trim() : value;

    // Prevent initial space only
    if (typeof value === "string" && value.length === 1 && value[0] === " ") {
      return;
    }

    // Validate max length
    if (typeof value === "string" && value.length > 30) {
      setError((prevError) => ({
        ...prevError,
        [name]: "Input cannot exceed 30 characters.",
      }));
      return;
    }

    // Validate empty string
    if (typeof value === "string" && trimmedValue === "") {
      setError((prevError) => ({
        ...prevError,
        [name]: "Input cannot be empty or just spaces.",
      }));
    } else {
      setError((prevError) => ({
        ...prevError,
        [name]: "",
      }));
    }

    // Always update the value
    setSelectedItemDetails((prevDetails) => ({
      ...prevDetails,
      [name]: value,
    }));
  };
  const handleFilterChange = (key, value) => {
    setFilters((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await externalgetApi(SETTING_API_07, "get", {
          COMPCODE,
          LOCCODE: STAFFMAPLOCODE,

          STS: CON_STATUS_ACTIVE,
        });

        setData(result);
        setFilteredRows(result); // Initialize filtered rows with all data
        console.log("result", result);
      } catch (err) {}
    };

    fetchData();
  }, []);

  useEffect(() => {
    const fetchTaxType = async () => {
      try {
        const result = await externalgetApi(SETTING_API_13, "get", {
          COMPCODE,
          LOCCODE: STAFFMAPLOCODE,
          TAXMPGCODE: CON_TAX_PAGE_CODE,
          STS: CON_STATUS_ACTIVE,
        });
        setDatatax(result); // Save doc types to
        console.log("tax types", result);
      } catch (error) {
        console.error("Error fetching GRN document types", error);
      }
    };
    fetchTaxType();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await externalgetApi(SUPPLIER_API_04, "get", {
          suprefcode: suprefcode,
          STS: CON_STATUS_ACTIVE,
        });

        setDatapro(result);

        console.log("result", result);
      } catch (err) {
        setError(err);
      }
    };

    fetchData();
  }, [suprefcode]);

  console.log("Selected Item Details:", suprefcode);
  useEffect(() => {
    if (!data) return;
    const filtered = data.filter(
      (row) =>
        (!filters.productname ||
          row.productname
            ?.toLowerCase()
            .includes(filters.productname.toLowerCase())) &&
        (!filters.catname ||
          row.catname?.toLowerCase().includes(filters.catname.toLowerCase())) &&
        (!filters.brandname ||
          row.brandname
            ?.toLowerCase()
            .includes(filters.brandname.toLowerCase()))
    );
    setFilteredRows(filtered);
  }, [filters, data]);

  const [selectedProduct, setSelectedProduct] = useState({
    productname: "",
    productcode: "",
  });

  const handleConfirmClick = async () => {
    setIsButtonDisabled(true);
    const { barcode, istax, productcode } = selectedItemDetails;

    const requiredFields = [
      { name: "barcode", value: barcode, label: "Bar Code" },
      { name: "istax", value: istax, label: "Tax Applicable" },
    ];

    // Only require taxcode if istax is "Y"
    if (istax === "Y") {
      requiredFields.push({
        name: "taxcode",
        value: selectedItemDetails.taxcode,
        label: "Tax Type",
      });
    }
    const missingRequiredFields = requiredFields.filter(
      (field) => !field.value
    );
    if (missingRequiredFields.length > 0) {
      const newError = {};
      missingRequiredFields.forEach((field) => {
        newError[field.name] = `${field.label} is required.`;
      });
      setError(newError);

      const missingFieldLabels = missingRequiredFields
        .map((field) => field.label)
        .join(", ");
      //  const errorMessage = `Required fields: ${missingFieldLabels}.`;
      const errorMessage = `Please Fill All the Required Fields.`;
      setAlertType("error");
      setAlertMessage("Please Fill All the Required Fields.");
      setAlertOpen(true); // Open the alert
      setIsButtonDisabled(false);
      return;
    }

    if (datapro) {
      const isDuplicate = datapro.some((item) => {
        if (
          item.supproductcode !== selectedItemDetails.supproductcode &&
          item.barcode.toLowerCase() === barcode.toLowerCase()
        ) {
          return true;
        } else {
          return false;
        }
      });

      if (isDuplicate) {
        setAlertMessage("Barcode Already Exists.");
        setAlertType("warning");

        setAlertOpen(true); // Open the alert
        return;
      }
    }

    if (datapro) {
      const isDuplicate = datapro.some((item) => {
        if (
          item.supproductcode !== selectedItemDetails.supproductcode &&
          item.productcode === selectedProduct.productcode
        ) {
          return true;
        } else {
          return false;
        }
      });

      if (isDuplicate) {
        setAlertMessage("Product Already Mapped.");
        setAlertType("warning");

        setAlertOpen(true); // Open the alert
        return;
      }
    }

    const BRAND_CODE = selectedItem ? selectedItem.supproductcode : 0;
    console.log("Brand Code:", BRAND_CODE);
    console.log("Selected Item Details:", suprefcode);
    const staticValues = {
      COMPCODE,
      businesstypecode: "O",
      suprefcode: suprefcode || 0,
      descrip: "",
      docpathjson: "",
      expdate: new Date().toISOString().split("T")[0],
      endate: new Date().toISOString().split("T")[0],
      STS: CON_STATUS_ACTIVE,
      ENUSER: USERNAME,
    };

    const payload = {
      ...selectedItemDetails,
      ...staticValues,
      productcode:
        selectedProduct.productcode || selectedItemDetails.productcode,
      supproductcode: BRAND_CODE,
      dtoDOCs: [
        {
          doctypecode: "",
          docpathjson: "",
          filename: "",
          bytarr: "",
          remark: "",
        },
      ],
    };

    try {
      console.log("Payload for API call:", payload);
      const responseData = await externalpostApi(SUPPLIER_API_04, payload);
      console.log("Success:", responseData);
      setAlertMessage(
        `${isEdit ? "Updated Successfully!" : "Product Mapped Successfully!"}`
      );
      setAlertType("success");

      setAlertOpen(true);
      handleClear();
      setTimeout(() => {
        navigate(-1);
      }, 2000);
    } catch (error) {
      console.error("Error:", error);
      setAlertType("error");
      setAlertMessage("An unexpected error occurred.");
      setAlertOpen(true); // Open the alert
    }
  };

  const handleClear = () => {
    setSelectedItemDetails({
      supproductcode: "",
      productname: "",
      productcode: "",
      barcode: "",
      istax: "",
      taxcode: "0",
      taxtype: "",
    });
    setSelectedProduct({
      productname: "",
      productcode: "",
    });
  };

  //     const filteredRows = sampleData.filter(row =>
  //   (!filters.productname || row.productname?.toLowerCase().includes(filters.productname.toLowerCase())) &&
  //   (!filters.catname || row.catname?.toLowerCase().includes(filters.catname.toLowerCase())) &&
  //   (!filters.brandname || row.brandname?.toLowerCase().includes(filters.brandname.toLowerCase()))
  // );
  return (
    <>
      {!isEdit && (
        <>
          <FilterProductSearch
            filters={filters}
            onFilterChange={handleFilterChange}
          />

          <Box sx={styles.view_page_container}>
            <ViewDataGridProduct
              columns={itemData.columns}
              rows={filteredRows.map((row) => ({
                ...row,
                id: row.productcode || Math.random(),
              }))}
              onActionClick={(row) => {
                setSelectedProduct({
                  productname: row.productname || "",
                  productcode: row.productcode || "",
                });
              }}
              getRowId={(row) => row.id}
              tabletitle={supplierData.name}
              gridid="suprefcode"
              sx={styles.view_data_grid_page}
            />
          </Box>
        </>
      )}

      <Box
        component="form"
        noValidate
        autoComplete="off"
        sx={{ ...styles.add_form_page_container, mb: 2 }}
      >
        <Grid container spacing={2} mt={2}>
          <Grid item size={{ xs: 12, sm: 12, md: 2, lg: 2, xl: 2 }}>
            <Typography sx={styles.supplier_sub_title_text}>
              Selected Product
            </Typography>
          </Grid>
          <Grid
            container
            spacing={2}
            size={{ xs: 12, sm: 12, md: 10, lg: 10, xl: 10 }}
          >
            <Grid item size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 6 }}>
              <TextField
                id="swift-code"
                label="Product Name"
                variant="outlined"
                fullWidth
                size="small"
                disabled
                name="Product Name"
                value={
                  selectedProduct.productname || selectedItemDetails.productname
                }
                FormHelperTextProps={{
                  sx: { fontSize: "12px", color: "red" },
                }}
              />
            </Grid>
            <Grid item size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 6 }}>
              <TextField
                label="Product code"
                variant="outlined"
                fullWidth
                size="small"
                disabled
                name="Product code"
                value={
                  selectedProduct.productcode || selectedItemDetails.productcode
                }
                FormHelperTextProps={{
                  sx: { fontSize: "12px", color: "red" },
                }}
              />
            </Grid>
          </Grid>
        </Grid>
      </Box>

      <Divider mt={2} mb={2} />
      <Box
        component="form"
        noValidate
        autoComplete="off"
        sx={{ ...styles.add_form_page_container, mb: 2 }}
      >
        <Grid container spacing={2} mt={2}>
          <Grid item size={{ xs: 12, sm: 12, md: 2, lg: 2, xl: 2 }}>
            <Typography sx={styles.supplier_sub_title_text}>
              Map Products
            </Typography>
          </Grid>
          <Grid
            container
            spacing={2}
            size={{ xs: 12, sm: 12, md: 10, lg: 10, xl: 10 }}
          >
            <Grid item size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 6 }}>
              <TextField
                id="swift-code"
                label="Barcode"
                variant="outlined"
                fullWidth
                size="small"
                required
                name="barcode"
                value={selectedItemDetails.barcode}
                onChange={handleInputChange}
                error={!!error.barcode}
                helperText={error.barcode}
                FormHelperTextProps={{
                  sx: { fontSize: "12px", color: "red" }, // Customize font size and color
                }}
              />
            </Grid>
            <Grid item size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 6 }}>
              <FormControl
                fullWidth
                size="small"
                required
                error={!!error.istax}
              >
                <InputLabel id="tax-applicable-label">
                  Tax Applicable
                </InputLabel>
                <Select
                  labelId="tax-applicable-label"
                  id="tax-applicable"
                  name="istax"
                  value={selectedItemDetails.istax || ""}
                  label="Tax Applicable"
                  onChange={handleInputChange}
                >
                  <MenuItem value="Y">Yes</MenuItem>
                  <MenuItem value="N">No</MenuItem>
                </Select>
                {error.istax && (
                  <FormHelperText sx={{ fontSize: "12px", color: "red" }}>
                    {error.istax}
                  </FormHelperText>
                )}
              </FormControl>
            </Grid>
            <Grid item size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 6 }}>
              <Autocomplete
                options={Array.isArray(datatax) ? datatax : []} // Ensure datacat is an array
                getOptionLabel={(option) => option.taxtype || ""} // Use catname or fallback to an empty string
                disableClearable
                disabled={selectedItemDetails.istax !== "Y"}
                value={
                  Array.isArray(datatax)
                    ? datatax.find(
                        (item) => item.taxcode == selectedItemDetails.taxcode
                      ) || null
                    : null
                } // Match the selected value or fallback to null
                onChange={(event, newValue) => {
                  handleInputChange({
                    target: {
                      name: "taxcode",
                      value: newValue ? newValue.taxcode : "", // Update catcode
                    },
                  });
                  handleInputChange({
                    target: {
                      name: "taxtype",
                      value: newValue ? newValue.taxtype : "", // Update catname
                    },
                  });
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Tax Type"
                    variant="outlined"
                    required={selectedItemDetails.istax === "Y"}
                    error={selectedItemDetails.istax === "Y" && !!error.taxcode}
                    helperText={
                      selectedItemDetails.istax === "Y" ? error.taxcode : ""
                    }
                    size="small"
                    name="taxtype"
                    FormHelperTextProps={{
                      sx: { fontSize: "12px", color: "red" }, // Customize font size and color
                    }}
                  />
                )}
                ListboxProps={{
                  style: {
                    maxHeight: 150,
                    backgroundColor: theme.palette.background.paper,
                  },
                }}
              />
            </Grid>
          </Grid>
        </Grid>
      </Box>

      <Box sx={styles.add_form_page_button_box}>
        <Button
          variant="outlined"
          size="medium"
          sx={{ ...styles.btn_secondary, ...styles.btn_add_cancel }}
          onClick={handleClear}
        >
          Clear
        </Button>
        <Button
          variant="contained"
          size="medium"
          sx={{ ...styles.btn_primary, ...styles.btn_add_confirm }}
          onClick={handleConfirmClick}
        >
          {isEdit ? "Modify" : "Confirm"}
        </Button>
      </Box>
      <SystemAlert
        open={alertOpen}
        type={alertType}
        message={alertMessage}
        onClose={() => setAlertOpen(false)}
      />
    </>
  );
};

export default ProductsBasicInfo;
